import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import LoadingPage from '@/common/pages/LoadingPage';
import InformationIconHeader from '@/modules/FileDetail/components/headers/InformationIconHeader.tsx';
import { damagesInformationQueryOptions } from '@/modules/FileDetail/queries/damagesInformation/damagesInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <DamagesInformationModal />
  </MainModal>
);

const DamagesInformationModal = () => {
  const { id } = useParams();

  const { data, isPending, isError } = useQuery(
    damagesInformationQueryOptions(id!),
  );
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        {data && data?.data.length > 1
          ? 'مشخصات زیان دیدگان'
          : 'مشخصات زیان‌دیده'}
      </TitleDescription>
      <Box>
        {data?.results?.map((item, index) => (
          <MainDetailCard key={index} className={css({ my: '25px' })}>
            <InformationIconHeader
              isApplicantUser={data.data[index].is_applicant_user}
              index={data && data?.data.length > 1 ? index + 1 : 0}
            />

            <DetailCardBody>
              <DetailCardItems backgroundColor="pink-1" items={item ?? []} />
            </DetailCardBody>
          </MainDetailCard>
        ))}
      </Box>
    </>
  );
};
